import { SnLocation } from '@lib/api/entities';
import { COLORS } from '@lib/ui/theme';
import { GoogleMapMarker, GoogleMapMarkerType } from '@lib/geo/google/map';

export class RegistryLocationMarker extends GoogleMapMarker {
  constructor(public readonly location: SnLocation) {
    super({
      type: GoogleMapMarkerType.CIRCLE,
      id: `location-${location.id}`,
      lonLat: location.geometry.coordinates,
      icon: {
        fontSet: 'fs',
        fontIcon: 'f03d',
        color: COLORS['grey-0'],
      },
      style: {
        strokeColor: COLORS['light-blue-500'],
        fillColor: COLORS['light-blue-500'],
        rotation: 0,
        scale: 0.75,
      },
    });
  }
}
